import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { checkLogin, apiError } from "../../store/actions";
import logodark from "../../assets/images/logo.svg";
import withRouter from "../../components/Common/withRouter";
import toastr from "toastr";

function Login(props) {
  const {
    handleSubmit,
    formState: { errors },
    control,
  } = useForm({
    defaultValues: {
      email: "",
      password: "",
    },
  });


  const hasMounted = React.useRef(false);
  useEffect(() => {
    if (!hasMounted.current) {
      hasMounted.current = true;
      return;
    }

    if (props.loginError) {
      let message = "Login failed";

      if (props.loginError.response?.data) {
        const { message: backendMessage } = props.loginError.response.data;

        if (Array.isArray(backendMessage)) {
          message = backendMessage[0];
        } else if (typeof backendMessage === "string") {
          message = backendMessage;
        }
      } else if (props.loginError.message) {
        message = props.loginError.message;
      }

      toastr.error(message, "Login Failed");
    }
  }, [props.loginError]);


  const onSubmit = (values) => {
    props.checkLogin(values, props.router.navigate);
  };

  useEffect(() => {
    props.apiError("");
    document.body.classList.add("auth-body-bg");

    return () => {
      document.body.classList.remove("auth-body-bg");
    };
  }, [props]);

  return (
    <React.Fragment>
      <div className="w-full">
        <div className="flex min-h-screen justify-center items-center flex-col py-5 bg-gray-50">
          <div className="mb-6">
            <Link to="/">
              <img
                src={logodark}
                alt="logo"
                className="mx-auto h-16"
              />
            </Link>
          </div>

          <div className="bg-white shadow-lg rounded-2xl w-full max-w-md">
            <div className="p-6 flex items-center">
              <div className="w-full">
                <div className="text-center">
                  <h4 className="text-2xl font-semibold mt-2">Welcome Back!</h4>
                  <p className="text-gray-500 text-base">Login to your account.</p>
                </div>

                <div className="mt-6">
                  <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
                    <div>
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                        Email
                      </label>
                      <Controller
                        name="email"
                        control={control}
                        rules={{ required: "userid is required" }}
                        render={({ field }) => (
                          <input
                            {...field}
                            type="text"
                            placeholder="Enter email"
                            className={`mt-1 block w-full rounded-lg border px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${errors.email ? "border-red-500" : "border-gray-300"
                              }`}
                          />
                        )}
                      />
                      {errors.email && (
                        <p className="text-red-500 text-xs mt-1">{errors.email.message}</p>
                      )}
                    </div>

                    <div>
                      <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                        Password
                      </label>
                      <Controller
                        name="password"
                        control={control}
                        rules={{ required: "Password is required" }}
                        render={({ field }) => (
                          <input
                            {...field}
                            type="password"
                            autoComplete="new-password"
                            id="password"
                            placeholder="Enter password"
                            className={`mt-1 block w-full rounded-lg border px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${errors.password ? "border-red-500" : "border-gray-300"
                              }`}
                          />
                        )}
                      />
                      {errors.password && (
                        <p className="text-red-500 text-xs mt-1">{errors.password.message}</p>
                      )}
                    </div>

                    <div className="flex items-center">
                      <input
                        id="customControlInline"
                        type="checkbox"
                        className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                      />
                      <label htmlFor="customControlInline" className="ml-2 mt-1.5 block text-sm text-gray-700">
                        Remember me
                      </label>
                    </div>

                    <div className="text-center">
                      <button
                        type="submit"
                        className="w-full bg-blue-600 text-white py-2 rounded-lg shadow hover:bg-blue-700 transition"
                      >
                        Log In
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-6 text-center text-sm text-gray-600">
            <p>
              Don&apos;t have an account?{" "}
              <Link to="/register" className="text-blue-600 hover:underline font-medium">
                Register
              </Link>
            </p>
            <p className="mt-2 text-xs text-gray-400">
              © 2025 ValSabji. Crafted with{" "}
              <span className="text-red-500">♥</span> by{" "}
              <Link to="https://www.valbeneti.com" target="_blank" rel="noreferrer" className="hover:underline">
                ValBeneti Ltd
              </Link>
            </p>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  const { loginError } = state.Login;
  return { loginError };
};

export default withRouter(
  connect(mapStateToProps, { checkLogin, apiError })(Login)
);